/* ============================================
   GURUBHAI EQUIPMENTS - GLOBAL JS
   Premium Commercial Kitchen Equipment
   ============================================ */

(function() {
  'use strict';

  // ============================================
  // SCROLL REVEAL ANIMATION
  // ============================================
  function initScrollReveal() {
    const revealElements = document.querySelectorAll('.gb-reveal, .gb-reveal-left, .gb-reveal-right, .gb-reveal-scale');
    
    if (!revealElements.length) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('gb-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    
    revealElements.forEach(el => observer.observe(el));
  }

  // ============================================
  // COUNTER ANIMATION
  // ============================================
  function animateCounter(el) {
    const target = parseInt(el.getAttribute('data-target') || el.textContent);
    const duration = 2000;
    const step = target / (duration / 16);
    let current = 0;
    const suffix = el.getAttribute('data-suffix') || '';
    const prefix = el.getAttribute('data-prefix') || '';
    
    const timer = setInterval(() => {
      current += step;
      if (current >= target) {
        current = target;
        clearInterval(timer);
      }
      el.textContent = prefix + Math.floor(current).toLocaleString() + suffix;
    }, 16);
  }

  function initCounters() {
    const counters = document.querySelectorAll('.gb-counter');
    if (!counters.length) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('gb-counted')) {
          entry.target.classList.add('gb-counted');
          animateCounter(entry.target);
        }
      });
    }, { threshold: 0.5 });
    
    counters.forEach(el => observer.observe(el));
  }

  // ============================================
  // STICKY HEADER
  // ============================================
  function initStickyHeader() {
    const header = document.querySelector('.gb-header-wrapper');
    if (!header) return;
    
    let lastScroll = 0;
    
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 80) {
        header.classList.add('gb-header-scrolled');
      } else {
        header.classList.remove('gb-header-scrolled');
      }
      
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // ============================================
  // TESTIMONIAL SLIDER
  // ============================================
  function initTestimonialSlider() {
    const sliders = document.querySelectorAll('.gb-testimonials-slider');
    
    sliders.forEach(slider => {
      const track = slider.querySelector('.gb-testimonials-track');
      const cards = slider.querySelectorAll('.gb-testimonial-card');
      const prevBtn = slider.querySelector('.gb-slider-prev');
      const nextBtn = slider.querySelector('.gb-slider-next');
      const dots = slider.querySelectorAll('.gb-slider-dot');
      
      if (!track || !cards.length) return;
      
      let current = 0;
      let perView = window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1;
      let maxIndex = Math.ceil(cards.length / perView) - 1;
      
      function updateSlider() {
        const cardWidth = track.parentElement.offsetWidth / perView;
        track.style.transform = `translateX(-${current * cardWidth * perView}px)`;
        dots.forEach((dot, i) => dot.classList.toggle('active', i === current));
      }
      
      function goNext() {
        current = current >= maxIndex ? 0 : current + 1;
        updateSlider();
      }
      
      function goPrev() {
        current = current <= 0 ? maxIndex : current - 1;
        updateSlider();
      }
      
      if (nextBtn) nextBtn.addEventListener('click', goNext);
      if (prevBtn) prevBtn.addEventListener('click', goPrev);
      dots.forEach((dot, i) => dot.addEventListener('click', () => { current = i; updateSlider(); }));
      
      // Auto-play
      let autoPlay = setInterval(goNext, 5000);
      slider.addEventListener('mouseenter', () => clearInterval(autoPlay));
      slider.addEventListener('mouseleave', () => { autoPlay = setInterval(goNext, 5000); });
      
      // Responsive
      window.addEventListener('resize', () => {
        perView = window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1;
        maxIndex = Math.ceil(cards.length / perView) - 1;
        current = 0;
        updateSlider();
      });
    });
  }

  // ============================================
  // MOBILE MENU
  // ============================================
  function initMobileMenu() {
    const hamburger = document.querySelector('.gb-hamburger');
    const mobileMenu = document.querySelector('.gb-mobile-menu');
    const closeBtn = document.querySelector('.gb-mobile-close');
    const overlay = document.querySelector('.gb-mobile-overlay');
    
    function openMenu() {
      mobileMenu?.classList.add('active');
      overlay?.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    
    function closeMenu() {
      mobileMenu?.classList.remove('active');
      overlay?.classList.remove('active');
      document.body.style.overflow = '';
    }
    
    hamburger?.addEventListener('click', openMenu);
    closeBtn?.addEventListener('click', closeMenu);
    overlay?.addEventListener('click', closeMenu);
  }

  // ============================================
  // SMOOTH SCROLL
  // ============================================
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          const headerHeight = document.querySelector('.gb-header-wrapper')?.offsetHeight || 80;
          const top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      });
    });
  }

  // ============================================
  // INIT ALL(function(){'use strict';function initScrollReveal(){const els=document.querySelectorAll('.gb-reveal,.gb-reveal-left,.gb-reveal-right,.gb-reveal-scale');if(!els.length)return;const obs=new IntersectionObserver((entries)=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('gb-revealed');obs.unobserve(e.target);}});},{threshold:0.1,rootMargin:'0px 0px -50px 0px'});els.forEach(el=>obs.observe(el));}function animateCounter(el){const target=parseInt(el.getAttribute('data-target')||el.textContent.replace(/[^0-9]/g,''));const duration=2000;const step=target/(duration/16);let current=0;const suffix=el.getAttribute('data-suffix')||'';const prefix=el.getAttribute('data-prefix')||'';const timer=setInterval(()=>{current+=step;if(current>=target){current=target;clearInterval(timer);}el.textContent=prefix+Math.floor(current).toLocaleString()+suffix;},16);}function initCounters(){const counters=document.querySelectorAll('.gb-counter');if(!counters.length)return;const obs=new IntersectionObserver((entries)=>{entries.forEach(e=>{if(e.isIntersecting&&!e.target.classList.contains('gb-counted')){e.target.classList.add('gb-counted');animateCounter(e.target);}});},{threshold:0.5});counters.forEach(el=>obs.observe(el));}function initStickyHeader(){const header=document.querySelector('.gb-header-wrapper');if(!header)return;window.addEventListener('scroll',()=>{header.classList.toggle('gb-header-scrolled',window.pageYOffset>80);},{passive:true});}function initTestimonialSlider(){const sliders=document.querySelectorAll('.gb-testimonials-slider');sliders.forEach(slider=>{const track=slider.querySelector('.gb-testimonials-track');const cards=slider.querySelectorAll('.gb-testimonial-card');const prevBtn=slider.querySelector('.gb-slider-prev');const nextBtn=slider.querySelector('.gb-slider-next');const dots=slider.querySelectorAll('.gb-slider-dot');if(!track||!cards.length)return;let current=0;let perView=window.innerWidth>=1024?3:window.innerWidth>=768?2:1;let maxIndex=Math.max(0,Math.ceil(cards.length/perView)-1);function updateSlider(){const w=track.parentElement.offsetWidth/perView;track.style.transform='translateX(-'+(current*w*perView)+'px)';dots.forEach((d,i)=>d.classList.toggle('active',i===current));}function goNext(){current=current>=maxIndex?0:current+1;updateSlider();}function goPrev(){current=current<=0?maxIndex:current-1;updateSlider();}if(nextBtn)nextBtn.addEventListener('click',goNext);if(prevBtn)prevBtn.addEventListener('click',goPrev);dots.forEach((d,i)=>d.addEventListener('click',()=>{current=i;updateSlider();}));let auto=setInterval(goNext,5000);slider.addEventListener('mouseenter',()=>clearInterval(auto));slider.addEventListener('mouseleave',()=>{auto=setInterval(goNext,5000);});window.addEventListener('resize',()=>{perView=window.innerWidth>=1024?3:window.innerWidth>=768?2:1;maxIndex=Math.max(0,Math.ceil(cards.length/perView)-1);current=0;updateSlider();});});}function initMobileMenu(){const hamburger=document.querySelector('.gb-hamburger');const mobileMenu=document.querySelector('.gb-mobile-menu');const closeBtn=document.querySelector('.gb-mobile-close');const overlay=document.querySelector('.gb-mobile-overlay');function openMenu(){mobileMenu?.classList.add('active');overlay?.classList.add('active');document.body.style.overflow='hidden';}function closeMenu(){mobileMenu?.classList.remove('active');overlay?.classList.remove('active');document.body.style.overflow='';}hamburger?.addEventListener('click',openMenu);closeBtn?.addEventListener('click',closeMenu);overlay?.addEventListener('click',closeMenu);}function init(){initScrollReveal();initCounters();initStickyHeader();initTestimonialSlider();initMobileMenu();}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}})();
  // ============================================
  function init() {
    initScrollReveal();
    initCounters();
    initStickyHeader();
    initTestimonialSlider();
    initMobileMenu();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

// Make product card images open the product details page.
(function () {
  function bindProductCardImage(card) {
    if (!card || card.dataset.gbImageLinkBound === 'true') return;

    var link = card.querySelector('a[href*="/products/"]');
    var imageArea = card.querySelector('.card__inner, .card__media, .media.media--hover-effect');

    if (!link || !imageArea) return;

    card.dataset.gbImageLinkBound = 'true';
    imageArea.style.cursor = 'pointer';
    imageArea.setAttribute('role', 'link');
    imageArea.setAttribute('tabindex', '0');
    imageArea.setAttribute('aria-label', link.textContent.trim() || 'View product details');

    function openProduct(event) {
      if (event.target.closest('a, button, input, select, textarea, label, summary')) return;
      window.location.href = link.href;
    }

    imageArea.addEventListener('click', openProduct);
    imageArea.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      window.location.href = link.href;
    });
  }

  function bindAllProductCardImages() {
    document.querySelectorAll('.card-wrapper.product-card-wrapper, .card-wrapper, li.grid__item').forEach(function (card) {
      bindProductCardImage(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAllProductCardImages);
  } else {
    bindAllProductCardImages();
  }

  document.addEventListener('shopify:section:load', bindAllProductCardImages);
})();


/* ==========================================================================
   B2B UI OVERHAUL — currency symbol (Rs. -> ₹) + stray gear-icon cleanup
   ========================================================================== */
(function () {
  var CURRENCY_RE = /Rs\.\s*(?=\d)/g;
  var GEAR_RE = /\s*[\u2699\uFE0F]+\s*/g;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TITLE: 1 };

  function cleanTextNode(node) {
    if (!node || !node.nodeValue) return;
    var updated = node.nodeValue.replace(CURRENCY_RE, "\u20B9").replace(GEAR_RE, " ");
    if (updated !== node.nodeValue) node.nodeValue = updated;
  }

  function acceptNode(node) {
    var p = node.parentNode;
    if (!p || SKIP_TAGS[p.nodeName]) return NodeFilter.FILTER_REJECT;
    return NodeFilter.FILTER_ACCEPT;
  }

  function walk(root) {
    if (root.nodeType === 3) { cleanTextNode(root); return; }
    if (root.nodeType !== 1 || SKIP_TAGS[root.nodeName]) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: acceptNode });
    var node;
    while ((node = walker.nextNode())) { cleanTextNode(node); }
  }

  function run() { walk(document.body); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === "characterData") {
        cleanTextNode(m.target);
      } else if (m.type === "childList") {
        m.addedNodes.forEach(function (n) { walk(n); });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();

/* =========================================================================
   Release reserved product-recommendations space
   Pairs with the product-recommendations min-height rule in gb-global.css,
   which reserves ~580px so the async "You may also like" fetch cannot shift
   the page (measured CLS was 0.105, now 0.000).
   Dawn adds .product-recommendations--loaded only when recommendations come
   back. If a product has none, that class never arrives and the reservation
   would leave an empty gap — this clears it once the fetch has settled.
   ========================================================================= */
(function () {
  function releaseRecommendationSpace() {
    var nodes = document.querySelectorAll('product-recommendations');
    Array.prototype.forEach.call(nodes, function (el) {
      var settled = false;
      function settle() {
        if (settled) return;
        settled = true;
        el.classList.add('gb-rec-settled');
        observer.disconnect();
      }
      var observer = new MutationObserver(settle);
      observer.observe(el, { childList: true, subtree: true });
      setTimeout(settle, 3000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', releaseRecommendationSpace);
  } else {
    releaseRecommendationSpace();
  }
})();

/* =========================================================================
   GB CONVERSION — sticky add-to-cart bar (17 Sep 2026)
   Pairs with the .gb-sticky-atc rules in gb-global.css.
   Product pages only. Progressive enhancement: if the Add-to-cart button
   is not found, nothing is built and the page behaves exactly as before.
   The bar simply re-triggers the real Add to cart button, so variant
   selection, quantity and cart behaviour stay untouched.
   ========================================================================= */
(function () {
  function init() {
    var atc = document.querySelector('.product-form__submit');
    if (!atc) return;
    if (document.querySelector('.gb-sticky-atc')) return;

    var infoEl = document.querySelector('.product__info-container');
    if (!infoEl) return;

    var titleNode = document.querySelector('.product__title h1')
                 || document.querySelector('.product__title h2')
                 || document.querySelector('.product__title');
    var title = titleNode ? titleNode.textContent.trim() : document.title;

    var priceNode = infoEl.querySelector('.price__sale .price-item--sale')
                 || infoEl.querySelector('.price__regular .price-item--regular')
                 || infoEl.querySelector('.price-item');
    var price = priceNode ? priceNode.textContent.trim() : '';

    var imgNode = document.querySelector('.product__media img');

    var bar = document.createElement('div');
    bar.className = 'gb-sticky-atc';

    if (imgNode && imgNode.currentSrc) {
      var img = document.createElement('img');
      img.className = 'gb-sticky-atc__img';
      img.src = imgNode.currentSrc;
      img.alt = '';
      bar.appendChild(img);
    }

    var info = document.createElement('div');
    info.className = 'gb-sticky-atc__info';

    var t = document.createElement('div');
    t.className = 'gb-sticky-atc__title';
    t.textContent = title;

    var p = document.createElement('div');
    p.className = 'gb-sticky-atc__price';
    p.textContent = price;

    info.appendChild(t);
    info.appendChild(p);
    bar.appendChild(info);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gb-sticky-atc__btn';
    btn.textContent = 'Add to cart';
    btn.addEventListener('click', function () { atc.click(); });
    bar.appendChild(btn);

    document.body.appendChild(bar);

    var io = new IntersectionObserver(function (entries) {
      var ctaOnScreen = entries[0].isIntersecting;
      bar.classList.toggle('is-visible', !ctaOnScreen);
      document.body.classList.toggle('gb-has-sticky-atc', !ctaOnScreen);
    }, { rootMargin: '0px 0px -40px 0px' });

    io.observe(atc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
